export const PREV_CURR_NEXT_NAVIGATION_SIZES = ['xs', 'sm', 'md', 'lg', 'xl'] as const;

export type PrevCurrNextNavigationSize = (typeof PREV_CURR_NEXT_NAVIGATION_SIZES)[number];
